(function () {
  'use strict';

  // Presentation only: the existing product/app handlers still own validation,
  // option values, prices, button availability and cart submission.
  function initRequiredOptionFeedback(root) {
    var configurator = root.querySelector('.iyra-purchase-configurator');
    var summary = root.querySelector('.add-flase-p');
    if (!configurator || !summary || root.dataset.iyraRequiredReady) return;
    root.dataset.iyraRequiredReady = 'true';

    var originalSummary = summary.textContent;
    var attempted = false;
    var syncTimer = 0;
    var motionTimer = 0;
    var records = [];
    var row = root.querySelector('.iyra-premium-checkout .product-form_flex');
    // Keep the alert above both quantity and Add to Cart, so they stay aligned.
    if (row) row.parentNode.insertBefore(summary, row);
    summary.classList.add('iyra-required-summary');
    summary.setAttribute('role', 'alert');
    summary.setAttribute('aria-atomic', 'true');

    function text(node) {
      return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    configurator.querySelectorAll('.custom-option-select').forEach(function (field, index) {
      var trigger = field.querySelector('.product-options-label');
      var value = trigger && trigger.querySelector(':scope > span');
      var label = field.querySelector(':scope > label');
      var delivery = !!field.querySelector('.false-deliviry');
      var required = delivery || (label && Array.prototype.some.call(label.children, function (child) {
        return text(child) === '*';
      }));
      if (!trigger || !value || !required) return;
      var labelText = label ? Array.prototype.filter.call(label.childNodes, function (node) {
        return node.nodeType === 3;
      }).map(function (node) { return text(node); }).join(' ').trim() : '';
      records.push({
        field: field, trigger: trigger, value: value, delivery: delivery,
        name: trigger.getAttribute('data-attr') || labelText || 'this option',
        id: 'iyra-required-' + (configurator.id || 'configurator') + '-' + index,
        message: null, invalid: false, originalAttributes: null
      });
    });

    function isMissing(record) {
      if (record.field.classList.contains('no-drop') || record.trigger.getAttribute('aria-disabled') === 'true') return false;
      if (!record.field.getClientRects().length || getComputedStyle(record.field).visibility === 'hidden') return false;
      var value = text(record.value).toLowerCase();
      return value === '' || value === 'select';
    }

    function setInvalid(record, invalid) {
      if (record.invalid === invalid) return;
      record.invalid = invalid;
      record.field.classList.toggle('iyra-field-missing', invalid);
      if (invalid) {
        if (!record.message) {
          record.message = document.createElement('p');
          record.message.className = 'iyra-field-error';
          record.message.id = record.id;
          record.message.textContent = record.delivery
            ? 'Please select a delivery option.'
            : 'Please select ' + record.name + '.';
          record.field.appendChild(record.message);
        }
        record.message.hidden = false;
        record.originalAttributes = {};
        ['aria-invalid', 'tabindex', 'role'].forEach(function (name) {
          record.originalAttributes[name] = record.trigger.getAttribute(name);
        });
        record.trigger.setAttribute('aria-invalid', 'true');
        var descriptions = (record.trigger.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (descriptions.indexOf(record.id) === -1) descriptions.push(record.id);
        record.trigger.setAttribute('aria-describedby', descriptions.join(' '));
        if (!record.trigger.hasAttribute('tabindex')) record.trigger.setAttribute('tabindex', '0');
        if (!record.trigger.hasAttribute('role')) record.trigger.setAttribute('role', 'button');
      } else {
        record.message.hidden = true;
        record.trigger.classList.remove('iyra-required-nudge');
        Object.keys(record.originalAttributes).forEach(function (name) {
          var previous = record.originalAttributes[name];
          if (previous === null) record.trigger.removeAttribute(name);
          else record.trigger.setAttribute(name, previous);
        });
        var remaining = (record.trigger.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
          return id && id !== record.id;
        });
        if (remaining.length) record.trigger.setAttribute('aria-describedby', remaining.join(' '));
        else record.trigger.removeAttribute('aria-describedby');
      }
    }

    function updateFeedback() {
      if (!attempted) return [];
      var missing = records.filter(isMissing);
      records.forEach(function (record) { setInvalid(record, missing.indexOf(record) !== -1); });
      if (missing.length) {
        var names = missing.map(function (record) { return record.name; }).join(', ');
        var copy = missing.length === 1 && missing[0].delivery
          ? 'Please select your delivery time before adding to cart.'
          : 'Please select the required options: ' + names + '.';
        if (summary.textContent !== copy) summary.textContent = copy;
        summary.classList.remove('hidden');
      } else {
        summary.classList.add('hidden');
        if (summary.textContent !== originalSummary) summary.textContent = originalSummary;
      }
      return missing;
    }

    function scheduleFeedback() {
      if (!attempted) return;
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(updateFeedback, 0);
    }

    function showFeedback() {
      attempted = true;
      var missing = updateFeedback();
      if (!missing.length) return;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var first = missing[0];
      first.trigger.focus({ preventScroll: true });
      first.field.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
      window.clearTimeout(motionTimer);
      records.forEach(function (record) { record.trigger.classList.remove('iyra-required-nudge'); });
      if (!reducedMotion) {
        // Restart the brief nudge on each unsuccessful attempt; never loop it.
        void first.trigger.offsetWidth;
        missing.forEach(function (record) { record.trigger.classList.add('iyra-required-nudge'); });
        motionTimer = window.setTimeout(function () {
          records.forEach(function (record) { record.trigger.classList.remove('iyra-required-nudge'); });
        }, 650);
      }
    }

    var placeholder = root.querySelector('.flase-add-to-cart');
    if (placeholder) {
      placeholder.setAttribute('role', 'button');
      placeholder.setAttribute('tabindex', '0');
    }
    root.addEventListener('click', function (event) {
      if (event.target.closest('.flase-add-to-cart, #AddToCart')) {
        // Let the existing handlers run first. Do not intercept submission.
        window.setTimeout(showFeedback, 0);
      } else {
        scheduleFeedback();
      }
    }, true);
    root.addEventListener('change', scheduleFeedback);
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var control = event.target.closest('.flase-add-to-cart, .iyra-field-missing .product-options-label');
      if (!control || control.tagName !== 'DIV' || event.target !== control) return;
      event.preventDefault();
      control.click();
    });
    // Watch only selected-label text, not prices or inputs. This also clears
    // feedback when the existing option scripts asynchronously reset a value.
    var observer = new MutationObserver(scheduleFeedback);
    records.forEach(function (record) {
      observer.observe(record.value, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    document.querySelectorAll('.iyra-product-page').forEach(initRequiredOptionFeedback);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
